import { FieldKey } from '@core/data-access/models/dynamic-form-field/dynamic-form-field.model';
import { FormFields } from '@core/data-access/models/form/form-store.model';
import { removeFormFields } from '@core/utils/form-fields/form-field-helpers';

export const removeBuyerInformationFormFields = (formFields: FormFields) =>
  removeFormFields(formFields, [
    FieldKey.Password,
    FieldKey.VerifyPassword,
    FieldKey.CreateAccount,
    FieldKey.CreateAccountButton,
    FieldKey.Newsletter,
    FieldKey.FairCatalogue,
    FieldKey.DifferentBillingAddress
  ]);
